interface OrderTrackingCardProps {
  className?: string;
}

export function OrderTrackingCard({ className }: OrderTrackingCardProps) {
  return (
    <div
      className={`absolute -top-4 lg:-top-10 right-0 flex flex-col items-start z-10 w-40 lg:w-[200px] p-3.5 lg:p-[18px] ${className || ''}`}
      style={{
        flexDirection: 'column',
        alignItems: 'flex-start',
        borderRadius: '20px',
        border: '1px solid rgba(59, 130, 246, 0.30)',
        background:
          'linear-gradient(161deg, rgba(20, 40, 80, 0.95) 0%, rgba(12, 28, 58, 0.95) 100%)',
        boxShadow:
          '0 0 50px 0 rgba(59, 130, 246, 0.12), 0 0 120px 0 rgba(59, 130, 246, 0.04), 0 16px 48px 0 rgba(0, 0, 0, 0.40), 0 1px 0 1px rgba(255, 255, 255, 0.08) inset, 0 0 30px 1px rgba(59, 130, 246, 0.03) inset',
        backdropFilter: 'blur(12px)',
      }}
    >
      <div
        style={{
          color: 'rgba(255, 255, 255, 0.40)',
          fontFamily: 'Inter',
          fontSize: '9px',
          fontWeight: '700',
          letterSpacing: '1.5px',
          textTransform: 'uppercase',
          marginBottom: '8px',
        }}
      >
        SİPARİŞ İZLEME
      </div>
      <div
        style={{
          color: '#FFF',
          textShadow: '0 0 30px rgba(255, 255, 255, 0.10)',
          fontFamily: 'Inter',
          fontSize: '38px',
          fontWeight: '800',
          lineHeight: '38px',
        }}
      >
        14.2
      </div>
      <div
        style={{
          display: 'flex',
          height: '40px',
          padding: '0 2px',
          justifyContent: 'center',
          alignItems: 'flex-end',
          gap: '4px',
          flexShrink: 0,
          alignSelf: 'stretch',
          marginTop: '12px',
          marginBottom: '12px',
        }}
      >
        {[...Array(7)].map((_, i) => {
          const heights = [
            '14px',
            '18px',
            '16px',
            '20px',
            '18px',
            '24px',
            '26px',
          ];
          const isHighlighted = i >= 5;
          return (
            <div
              key={i}
              style={{
                height: heights[i],
                minWidth: '8px',
                flex: '1 0 0',
                borderRadius: '2px',
                background: isHighlighted
                  ? 'linear-gradient(180deg, #818CF8 0%, #6366F1 40%, #3B82F6 100%)'
                  : 'linear-gradient(180deg, #818CF8 0%, #6366F1 40%, #3B82F6 100%)',
                boxShadow: '0 0 8px 0 rgba(99, 102, 241, 0.35)',
              }}
            />
          );
        })}
      </div>
      <div
        style={{
          color: 'rgba(255, 255, 255, 0.40)',
          fontFamily: 'Inter',
          fontSize: '9px',
          fontWeight: '700',
          letterSpacing: '1.5px',
          textTransform: 'uppercase',
        }}
      >
        Sipariş Hızı
      </div>
    </div>
  );
}
